// 定義內容
export default {
	label: {
		one1: '使用者名稱登入',
		two2: '手機號碼登入',
	},
	link: {
		one3: '第三方登入',
		two4: '友情連結',
	},
	account: {
		accountPlaceholder1: '使用者名稱 admin 或不輸皆為 common',
		accountPlaceholder2: '密碼：123456',
		accountPlaceholder3: '請輸入驗證碼',
		accountBtnText: '登 錄',
	},
	mobile: {
		placeholder1: '請輸入手機號碼',
		placeholder2: '請輸入驗證碼',
		codeText: '取得驗證碼',
		invitationCodeText: '邀請碼',
		btnText: '登 錄',
		msgText: '* 溫馨提示：建議使用Google、Microsoft Edge，版本 79.0.1072.62 以上瀏覽器，360瀏覽器請使用極速模式',
	},
	scan: {
		text: '打開手機掃一掃，快速登入/註冊',
	},
	signInText: '歡迎回來！ ',
	router: {
		home: '首頁',
		chat: '智能問答',
		file: '知識庫',
		uie: 'UIE',
		personage: '人物庫',
		system: '系統設定',
		systemMenu: '通用佈局',
		systemRole: '資料錄入',
		systemUser: '數據展示',
		systemDept: '部門管理',
		systemDic: '字典管理',
		layoutLinkView: '外鏈',
		layoutIframeViewOne: '內嵌 iframe1',
		layoutIframeViewTwo: '內嵌 iframe2',
	},
	staticRoutes: {
		signIn: '登入',
		notFound: '找不到此頁',
		noPower: '沒有權限',
	},
	user: {
		title1: '語言切換',
		title3: '佈局配置',
		title4: '消息',
		title5: '開全螢幕',
		title6: '關全螢幕',
		dropdown1: '首頁',
		dropdown2: '個人中心',
		dropdown3: '404',
		dropdown4: '401',
		dropdown5: '登出登入',
		newTitle: '通知',
		newBtn: '全部已讀',
		newGo: '前往通知中心',
		newDesc: '暫無通知',
		logOutTitle: '提示',
		logOutMessage: '此動作將退出登錄，是否繼續？ ',
		logOutConfirm: '確定',
		logOutCancel: '取消',
		logOutExit: '退出',
		small: '小',
		default: '中',
		large: '大',
	},
	tagsView: {
		refresh: '刷新',
		close: '關閉',
		closeOther: '關閉其它',
		closeAll: '全部關閉',
		fullscreen: '目前頁全螢幕',
		closeFullscreen: '關閉全螢幕',
	},
	notFound: {
		foundTitle: '位址輸入錯誤，請重新輸入位址~',
		foundMsg: '您可以先檢查網址，然後重新輸入或給我們回饋問題。 ',
		foundBtn: '返回首頁',
	},
	noAccess: {
		accessTitle: '您未被授權，沒有操作權限~',
		accessBtn: '重新授權',
	},
	layout: {
		themeColor: '主題顏色',
		configTitle: '佈局配置',
		oneTitle: '全域主題',
		twoTopTitle: '頂欄設定',
		twoMenuTitle: '選單設定',
		twoTopBar: '頂欄背景',
		twoTopBarColor: '頂欄預設字體顏色',
		twoMenuBar: '菜單背景',
		twoMenuBarColor: '選單預設字體顏色',
		twoMenuBarActiveColor: '選單高亮背景色',
		threeTitle: '介面設定',
		threeIsCollapse: '選單水平折疊',
		threeIsUniqueOpened: '菜單手風琴',
		threeIsFixedHeader: '固定 Header',
		threeIsClassicSplitMenu: '經典佈局分割選單',
		fourTitle: '介面顯示',
		fourIsShowLogo: '側邊欄 Logo',
		fourIsBreadcrumb: '開啟 Breadcrumb',
		fourIsBreadcrumbIcon: '開啟 Breadcrumb 圖示',
		fourIsTagsview: '開啟 Tagsview',
		fourIsTagsviewIcon: '開啟 Tagsview 圖示',
		fourIsCacheTagsView: '開啟 TagsView 快取',
		fourIsSortableTagsView: '開啟 TagsView 拖曳',
		fourIsShareTagsView: '開啟 TagsView 共用',
		fourIsFooter: '開啟 Footer',
		fourIsGrayscale: '灰色模式',
		fourIsDark: '深色模式',
		fourIsWartermark: '開啟水印',
		fourWartermarkText: '水印文案',
		fiveTitle: '其它設定',
		fiveTagsStyle: 'Tagsview 風格',
		fiveAnimation: '主頁切換動畫',
		sixTitle: '佈局切換',
		sixDefaults: '預設',
		sixClassic: '經典',
		sixTransverse: '橫向',
		tipText: '點選下方按鈕，複製版面配置去 `src/stores/themeConfig.ts` 修改。 ',
		copyText: '一鍵複製配置',
		resetText: '一鍵恢復預設',
		copyTextSuccess: '複製成功！ ',
		copyTextError: '複製失敗！ ',
	},
	stepForm: {
		form: {
			activityName: '活動名稱',
			channelType: '頻道類型',
			promotionTime: '推廣時間',
			promoteLink: '推廣地址',
		},
		placeholder: {},
	},
	uie: {
		introTitleUIE: 'YAYI-UIE精準的',
		introTitleExtrac: '知識抽取',
		introTitleAI: 'AI助理',
		introTitleMain: '基於百萬級中英雙語料，結合有監督微調與人類意圖對齊，在信息抽取領域表現突出，支持輿情、媒宣、金融、安全等領域複雜場景信息抽取。 ',
		enterkeyword: '輸入關鍵字',
		enterDetail: '進入',
		extractInfor: '抽取資訊',
		extractContent: '抽取內容',
		extractResults: '抽取結果',
		copyJSON: '複製JSON',
		extractionProgress: '正在抽取中',
		sendExtractedView: '左側發送抽取內容後查看',
		record: '記錄',
		historyRecord: '歷史記錄',
		confirmDeletSession: '確認刪除此會話',
		confirm: '確認',
		cancel: '取消',
		submit: '提交',
		nohistory: '暫無歷史記錄',
		feedbackMeansLot: '您的回饋對我們意義重大，希望您填寫您認為',
		moreDesAnswer: '您認為更理想的答案是什麼？ ',
		abnormalNetwork: '目前網絡異常，請檢查網絡',
		copySuccessful: '複製成功',
		likeSuccess: '按讚成功',
		tapSuccess: '點踩成功',
		hisNameNoEmpty: '歷史記錄名稱不能為空',
	},
};
